import createTransition from './createTransition';
import styles from './Fade.scss';

export default createTransition('Fade', styles);
